module.exports = __webpack_public_path__ + "static/media/income.95eda9f1.svg";